import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

const SectionHeader = ({ title, content, width = 0 }) => {
  const control = useAnimation();
  const [ref, inView] = useInView([]);
  const boxVariant = {
    hidden: {
      x: -200,
    },
    visible: {
      x: 0,
    },
  };
  useEffect(() => {
    if (inView) {
      control.start("visible");
    }
  }, [control, inView]);
  return (
    <motion.div
      ref={ref}
      variants={boxVariant}
      initial="hidden"
      animate={control}
      transition={{ duration: 0.5 }}
      className={`${
        width === 0 ? "col-lg-6 col-md-6" : "col-lg-12 col-md-12"
      } col-sm-12 col-xs-12 page-section-title`}
    >
      <h4 className="title">{title}</h4>
      <p className="content">{content}</p>
    </motion.div>
  );
};

export default SectionHeader;
